import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=6c10e2d7&scoped=true"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=6c10e2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c10e2d7",
  null
  
)

export default component.exports